<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">

                    <div id="login_block">
                        <!-- <logoSight /> -->
                        <h3 class="login_title title has-text-grey">{{ $t('modules.auth.login.title') }}</h3>
                        <p class="subtitle has-text-grey ">{{ $t('modules.auth.login.notice') }}</p>
                        <form class="login" @submit.prevent="login" novalidate="true">
                                <InputMaterialWrap
                                    v-model="email"
                                    label="Email"
                                    inputType="email"
                                    validate='email|required'
                                    input-id="loginEmail">
                                </InputMaterialWrap>

                                <InputMaterialWrap
                                    v-model="password"
                                    label="Mot de passe"
                                    inputType="password"
                                    validate='required'
                                    input-id="loginPassword">
                                </InputMaterialWrap>

                            <button :class="{'is-loading': isLoading}" class="login_submit is-large button is-outlined is-info">{{ $t('modules.auth.login.button') }}</button>

                        </form>

                    </div>

                </div>
            </div>
        </div>

        <transition name="notif-slide-up">
            <alert class="login_notif" v-if="showErrorNotif" context="danger" @close="showErrorNotif=false">{{ $t('modules.auth.login.error') }}</alert>
        </transition>

    </section>
</template>

<script>
import LogoSight from '@/components/layouts/logoSight'
export default {

    name: 'Login',
    components: {
        LogoSight
    },
    data(){
      return {
        email : "",
        password : "",
        showErrorNotif: false,
        isLoading: false
      }
    },
    computed: {
        formIsValid(){
            if (this.fields.loginEmail && this.fields.loginPassword){
                return (this.fields.loginEmail.valid && this.fields.loginPassword.valid)
            }else{
                return false
            }
        }
    },
    methods: {
        login: function () {
            this.$validator.validateAll()
            if (this.formIsValid){
                this.isLoading = true
                let email = this.email
                let password = this.password
                this.$store.dispatch('UserStore/login', { email, password })
                .then((res) => {
                    if(res && res.status == 200){
                        this.$router.push('/')
                    }else{
                        this.showErrorNotif = true
                    }
                    this.isLoading = false
                })
            }

        }
    }
}

</script>

<style lang="scss">
#login_block{
    margin-bottom: 150px;
    .login_title {
        font-size: 3rem;
        text-transform: uppercase;
        color: $grey-light!important;
        margin-bottom: 80px;
    }
}
.notification.login_notif{
    width: 750px!important;
    left: calc(50% - 375px)!important;
}

</style>
